import { useSelector } from 'react-redux';

const useAppData = () => {
  const app = useSelector((state: any) => state?.financialData?.data);
  return {
    app,
  };
};

export default useAppData;
